import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useHeader } from './../../components/HeaderContext';
import { useAxiosPrivate } from "./../../hooks/useAxiosPrivate";
import useAuth from "./../../hooks/useAuth.js";
import { useAlert } from './../../components/AlertContext.jsx';
import LotsForm from '../purchase_orders/lots_form.js';  // Adjust the import path as needed
import "./../../App.css";

const LotsEdit = () => {
    const { id } = useParams();
    const location = useLocation();
    const { lot_code, supplier_id } = location.state || {};

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();
    const { setHeader } = useHeader();
    const navigate = useNavigate();
    const ReturnPage = "/lots";

    const [lotsFormData, setLotsFormData] = useState({
        lot_code: '',
        lot_id: '',
        supplier_id: '',
        quantity: '',
        shipment_document_no: '',
        notes: '',
        shipment_id: '',
        shipment_notes: '',
        shipment_files: [],
        components_composition: [
            {
                components_composition_id: '',
                sequence: '',
                material_id: '',
                percentage: '',
                components_composition_supplier: [
                    {
                        components_composition_sub_supplier_id: '',
                        sub_supplier_name: '',
                        country_id: '',
                        state_province: '',
                        transport_type: '',
                        production_process: '',
                        dyeing: false,
                        dyeing_supplier_name: '',
                        dyeing_country_id: '',
                        dyeing_state_province: '',
                        dyeing_transport_type_id: '',
                        files: []
                    }
                ]
            }
        ]
    });

    // Set the page header
    useEffect(() => {
        setHeader("View Lot");
    }, [setHeader]);


    useEffect(() => {
        const fetchData = async () => {
            await fetchDataForForm();
        };
        fetchData();
    }, []);


    const fetchDataForForm = async () => {
        try {
            const response = await axiosPrivate.get(
                `${baseURL}/purchase-order-supplier-lot?lot_code=${lot_code}&supplier_id=${supplier_id}`
            );

            const mappedData = {
                lot_code: response.data[0].lot_code || '',
                lot_id: response.data[0].lot_id || '',
                supplier_id: response.data[0].supplier_id || '',
                quantity: '',
                shipment_document_no: '',
                notes: response.data[0].notes || '',
                shipment_id: '',
                shipment_files: [],
                components_composition: response.data.flatMap((lot) =>
                    lot.components_composition.map((comp) => ({
                        components_composition_id: comp.components_composition_id || '',
                        sequence: comp.sequence || '',
                        material_id: comp.material_id || '',
                        percentage: comp.percentage || '',
                        components_composition_supplier: comp.components_composition_supplier.map((supplier) => ({
                            components_composition_sub_supplier_id: supplier.components_composition_sub_supplier_id || '',
                            sub_supplier_name: supplier.sub_supplier_name || '',
                            country_id: supplier.country_id || '',
                            state_province: supplier.state_province || '',
                            transport_type: supplier.transport_type_id || '',
                            production_process: supplier.production_process || '',
                            dyeing: supplier.dyeing || false,
                            dyeing_supplier_name: supplier.dyeing_supplier_name || '',
                            dyeing_country_id: supplier.dyeing_country_id || '',
                            dyeing_state_province: supplier.dyeing_state_province || '',
                            dyeing_transport_type_id: supplier.dyeing_transport_type_id || '',
                            files: supplier.files || [],
                        })),
                    }))
                ),
            };


            // If components_composition is empty, initialize it with one empty object
            if (mappedData.components_composition.length === 0) {
                mappedData.components_composition = [
                    {
                        components_composition_id: '',
                        sequence: '',
                        material_id: '',
                        percentage: '',
                        components_composition_supplier: [
                            {
                                components_composition_sub_supplier_id: '',
                                sub_supplier_name: '',
                                country_id: '',
                                state_province: '',
                                transport_type: '',
                                production_process: '',
                                dyeing: false,
                                dyeing_supplier_name: '',
                                dyeing_country_id: '',
                                dyeing_state_province: '',
                                dyeing_transport_type_id: '',
                                files: [],
                            },
                        ],
                    },
                ];
            }

            setLotsFormData(mappedData);
        } catch (error) {
            console.error("Error fetching lot data", error);
        }
    };






    return (
        <div className="d-flex align-items-center mt-1">
            <div className="p-2 rounded w-100">
                <div>
                    <LotsForm
                        lotsFormData={lotsFormData}
                        setLotsFormData={setLotsFormData}
                        disabled={!!lotsFormData.lot_id} // Disable if lot_id exists
                    />

                    <div className="mt-3">
                        <button
                            className="btn btn-outline-success"
                            style={{ marginRight: '20px', marginTop: '10px' }}
                            onClick={() => navigate(ReturnPage)}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LotsEdit;